import React, { useCallback, useEffect, useState } from 'react';
import { DynamicForm } from '../dynamic-form';
import { SubmitBtn } from '../submit-btn';
import { useApi, useAuth } from '../../hooks';
import CommentList from './comment-list';

type CommentsProps = {
  reportId: number;
};

export const Comments = ({ reportId }: { reportId: number }) => {
  const { addComment, getComments } = useApi();
  const { auth } = useAuth();
  const [comments, setComments] = useState();

  const listComments = useCallback(async () => {
    try {
      const response = await getComments(reportId);
      setComments(response);
    } catch (error) {
      console.log('error', error);
    }
  }, [reportId, getComments]);

  const handleOnSubmit = useCallback(
    async ({ comment }, { setFieldValue }) => {
      try {
        await addComment({ comment, userName: auth.userName, reportId });
        setFieldValue('comment', '');
        listComments();
      } catch (error) {}
    },
    [addComment, listComments, auth, reportId]
  );

  useEffect(() => {
    listComments();
  }, [listComments]);
  return (
    <div>
      <CommentList comments={comments} />
      <DynamicForm
        fields={{
          comment: {
            type: 'text',
            label: 'Commentaire',
            multiline: true,
            rows: 4,
            rowsMax:15
          },
        }}
        onSubmit={handleOnSubmit}
      >
        {(form: any) => (
          <SubmitBtn
            variant="contained"
            color="primary"
            title="Envoyer"
            disabled={!form.isValid || form.isSubmitting || !form.values.comment}
            isSubmitting={form.isSubmitting}
          />
        )}
      </DynamicForm>
    </div>
  );
};

export default Comments;
